import React from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import { NexusAdminHeader } from './NexusAdminHeader';
import { NexusAdminSidebar } from './NexusAdminSidebar';

interface NexusAdminLayoutProps {
  children: React.ReactNode;
  title: string;
  activeSection: string;
  userName?: string;
  userRole?: string;
}

export const NexusAdminLayout: React.FC<NexusAdminLayoutProps> = ({
  children,
  title,
  activeSection,
  userName,
  userRole,
}) => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');

  return (
    <Flex h="100vh" overflow="hidden">
      <NexusAdminSidebar activeSection={activeSection} />
      
      <Box flex={1} bg={bgColor} overflow="auto">
        <NexusAdminHeader 
          title={title}
          userName={userName}
          userRole={userRole}
        />
        <Box p={6}>
          {children}
        </Box>
      </Box>
    </Flex>
  );
};
